import ProjectManage from "models/project-manage";
const projectManage = new ProjectManage();
import { formatTimeToDate } from "common/js/util";

export default {
  data() {
    return {
      selectedTab: '基本信息',
      switchList: [
        { name: '基本信息' },
        { name: '场租计费规则' },
        { name: '操作收入计费规则' },
        { name: '物流计费规则' },
      ],
      projectBaseInfoFrom: {},
      projectRentalCostsFrom: {},
      projecttOperationFrom: {},
      cityDeliveryUnitPrice: '',
      projectsName: '',
      headList: [],
      serviceNameList: [],
      // 数据来源列表
      dataSourceList: [
        {
          id: 1,
          name: "WMS",
        },
        {
          id: 2,
          name: "易仓储",
        },
      ],
      disabledList: [
        { name: "无", id: false },
        { name: "有", id: true },
      ],
      // 坪数规则列表
      areaUtilization: [
        {
          id: 1,
          name: "差额收费",
        },
        {
          id: 2,
          name: "全额收费",
        },
      ],
      // 计费类型列表
      expressMethodList: [
        {
          id: 1,
          name: "计重",
        },
        {
          id: 2,
          name: "现场定价",
        },
        {
          id: 3,
          name: "计体积",
        },
      ],
      // 综合保底类型列表
      comprehensiveMinimumGuaranteeList: [
        { name: "保底面积", id: 1 },
        { name: "保底金额", id: 2 },
      ],
      // 场地月保底类型列表
      guaranteedRentPriceList: [
        { name: "场地月保底", id: 1 }
      ],
      // 操作保底类型列表
      guaranteedOperatePriceList: [
        { name: "金额保底", id: 'fee' },
        { name: "日单量保底", id: 'dailyOrderQuantity' },
        { name: "月单量保底", id: 'monthlyOrderQuantity' },
      ],
      guaranteedOperateUnitObj: {
        'fee': '元/月',
        'dailyOrderQuantity': '单/天',
        'monthlyOrderQuantity': '单/月',
      },
      // 计费依据
      chargeFoundationList: [
        {id:1, name: '商品数量'},
        {id:2, name: '包裹数量'},
      ]
    }
  },
  created() {
  },
  methods: {
    /**
     * @desc 负责人列表
    */
    initHeadList() {
      projectManage.getEmployeeList().then((res) => {
        let headList = [];
        res.result.map((value) => {
          let obj = {};
          obj.id = value.id;
          obj.name = value.name;
          headList.push(obj);
        });
        this.headList = headList;
      });
    },

    /**
     * @desc 获取服务名称列表
     */
    initServiceNameList() {
      projectManage.getServiceNameList().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.serviceName = value.serviceName;
            arr.push(obj);
          });
          this.serviceNameList = arr;
        }
      });
    },

    changeTab(v) {
      this.selectedTab = v
    },

    /**
     * @desc 获取详情数据
     */
    projectDetail() {
      let id = Number(this.$route.query.projectId);
      projectManage.getProjectDetail(id).then((res) => {
        if (res.success) {
          let {
            projectToken, customerId, projectsName, businessOwner1, contractBeginTime,
            contractEndTime, dataSource, logisticTaxRate, rentChargeConfig, shareArea,
            finalOrderTime, warehouseId, useArea, operatorCharge, returnCharge, bulkUnitPrice,
            unloadUnitPrice, extraServiceList, cityDeliveryUnitPrice, expressCusRuleBaseInfoList,
            logisticsInterceptChargeFlag, pileConversionFactor, shelfConversionFactor, baseGuaranteedRule,
            operateGuaranteedRule, storageTaxRate, operatorTaxRate, minimumFeeRule, taxRate, orderCancelUnitPrice,
            remark, createTime, projectsDesc
          } = res.result

          let date = contractBeginTime
            ? [
              formatTimeToDate(contractBeginTime),
              formatTimeToDate(contractEndTime),
            ]
            : "";
          let contractArea = Number(rentChargeConfig.data.contractArea) === 0 ? '' : rentChargeConfig.data.contractArea;
          let hasExtraFee = minimumFeeRule.hasExtraFee === 1?true: false
          let hasCityMatching = minimumFeeRule.hasCityMatching === 1 ? true : false
          let hasCancelOrder = minimumFeeRule.hasCancelOrder === 1 ? true : false
          let hasOpenComprehensiveMinimumGuarantee = true
          let comprehensiveMinimumGuaranteeType = 1
          let comprehensiveMinimumGuaranteeAmount = null
          if (!baseGuaranteedRule) {
            hasOpenComprehensiveMinimumGuarantee = false
          } else {
            comprehensiveMinimumGuaranteeAmount = baseGuaranteedRule.ruleType === 'area' ? baseGuaranteedRule.baseGuaranteedUnitPrice : baseGuaranteedRule.minimumFee
            comprehensiveMinimumGuaranteeType = baseGuaranteedRule.ruleType === 'area'?1:2
          }
          let projectBaseInfoFrom = {
            projectToken,
            createTime,
            customerId,
            projectName: projectsName,
            head: businessOwner1,
            date,
            dataSource,
            taxRate,
            logisticTaxRate,
            contractArea,
            shareArea,
            finalOrderTime,
            logisticsInterceptChargeFlag,
            hasExtraFee,
            hasCityMatching,
            hasCancelOrder,
            hasOpenComprehensiveMinimumGuarantee,
            comprehensiveMinimumGuaranteeType,
            comprehensiveMinimumGuaranteeAmount,
            remark,
            projectsDesc
          }


          let rentPriceMonth = Number(rentChargeConfig.data.rentPriceMonth) === 0 ? '' : rentChargeConfig.data.rentPriceMonth;
          let guaranteedRentPrice =
            Number(rentChargeConfig.data.guaranteedRentPrice) === 0
              ? ""
              : Number(rentChargeConfig.data.guaranteedRentPrice);
          let guaranteedRentPriceStatus =
            Number(rentChargeConfig.data.guaranteedRentPrice) === 0 ? false : true;
          let guaranteedRentPriceType = 1
          let area =
            Number(rentChargeConfig.data.areaUtilization) === 0 ? "" : Number(rentChargeConfig.data.areaUtilization);
          let areaUtilizationType =
            Number(rentChargeConfig.data.areaUtilizationType) === 0
              ? ""
              : Number(rentChargeConfig.data.areaUtilizationType);
          let areaStatus =
            Number(rentChargeConfig.data.areaUtilization) === 0 ? false : true;

          let venueDiscounts = rentChargeConfig.data.rentDiscount === 0 ? false : true
          let venueDiscountsType = rentChargeConfig.data.rentDiscount ? rentChargeConfig.data.rentDiscount : 1
          let reduceArea = rentChargeConfig.data.reduceArea
          let projectRentalCostsFrom = {
            warehouseId,
            useArea,
            rentPriceMonth,
            guaranteedRentPrice,
            guaranteedRentPriceStatus,
            area,
            areaStatus,
            areaUtilizationType,
            pileConversionFactor,
            shelfConversionFactor,
            guaranteedRentPriceType,
            storageTaxRate,
            venueDiscounts,
            venueDiscountsType,
            reduceArea
          }


          let startPrice = operatorCharge.unitPrice;
          let chargeFoundation = operatorCharge.chargeFoundation;
          let additionalCosts = Number(operatorCharge.excessUnitPrice) === 0 ? "" : Number(operatorCharge.excessUnitPrice);
          let number =
            Number(operatorCharge.quantityLimit) === 0 ? "" : Number(operatorCharge.quantityLimit);
          let numberStatus =
            Number(operatorCharge.quantityLimit) === 0 ? false : true;
          

          let guaranteedOperatePriceStatus = true
          let guaranteedOperatePrice = null
          let guaranteedOperatePriceType = 'fee'
          if (!operateGuaranteedRule) {
            guaranteedOperatePriceStatus = false
          } else {
            guaranteedOperatePriceType = operateGuaranteedRule.ruleType
            if (operateGuaranteedRule.ruleType === 'fee') {
              guaranteedOperatePrice = operateGuaranteedRule.baseAmount
            } else {
              guaranteedOperatePrice = operateGuaranteedRule.baseOrderQuantity
            }
          }

          let returnStartingPrice = returnCharge ? returnCharge.unitPrice : '';
          let returnPriceOfSuperParts = returnCharge ?
            (Number(returnCharge.excessUnitPrice) === 0 ? "" : Number(returnCharge.excessUnitPrice)) : '';

          let rangeOfReturnedItems = returnCharge ?
            (Number(returnCharge.quantityLimit) === 0 ? "" : returnCharge.quantityLimit) : ''
          let rangeOfReturnedItemsStatus = returnCharge ?
            (Number(returnCharge.quantityLimit) === 0 ? false : true) : false;
          let bulkDeliveryPrice = bulkUnitPrice;
          let unloadingPrice = unloadUnitPrice;
          let domains = extraServiceList
          let projecttOperationFrom = {
            chargeFoundation,
            startPrice,
            number,
            numberStatus,
            orderCancelUnitPrice,
            additionalCosts,
            guaranteedOperatePriceType,
            guaranteedOperatePrice,
            guaranteedOperatePriceStatus,
            returnStartingPrice,
            returnPriceOfSuperParts,
            rangeOfReturnedItems,
            rangeOfReturnedItemsStatus,
            bulkDeliveryPrice,
            unloadingPrice,
            domains,
            operatorTaxRate
          }

          this.projectBaseInfoFrom = projectBaseInfoFrom
          this.projectRentalCostsFrom = projectRentalCostsFrom
          this.projecttOperationFrom = projecttOperationFrom
          this.cityDeliveryUnitPrice = cityDeliveryUnitPrice;

          let expressTabs = []
          expressCusRuleBaseInfoList.map(i => {
            let obj = {}
            obj.id = i.expressType
            obj.name = i.expressType === 29 ? '市内配送' : i.expressName
            obj.expressMethod = i.expressMethod
            if (i.expressMethod) {
              let expressMethodObj = this.expressMethodList.find(item => { return item.id == i.expressMethod })
              obj.expressMethodName = expressMethodObj.name
            }
            obj.tableList = []
            if (i.ruleList) {
              let ruleListArr = i.ruleList.sort((a, b) => { return a.sort - b.sort })
              ruleListArr.map(j => {
                let obj2 = {}
                obj2.name = `表格${j.sort}`
                obj2.expressRuleRoundTypeReqVoList = j.roundTypeList
                obj2.sectionList = []
                obj2.tableTitle = []
                obj2.tableData = []
                j.section.map(k => {
                  let obj3 = {}
                  let obj4 = {}
                  obj3.begin = k.begin
                  obj3.end = k.end
                  obj3.unitWeight = k.unitWeight
                  obj3.fixedPrice = k.fixedPrice ? true : false;
                  obj4.fixedPrice = k.fixedPrice ? true : false;
                  obj4.value = k.begin + "-" + k.end;
                  obj4.unitWeight = k.unitWeight;
                  obj2.sectionList.push(obj3)
                  obj2.tableTitle.push(obj4);
                })

                j.rules.map(r => {
                  let obj5 = {}
                  obj5.province = r.province
                  obj5.ruleDetail = r.ruleDetail;
                  r.ruleDetail.map(v => {
                    if (v.over === 0) {
                      obj5[v.begin + "-" + v.end] = v.price;
                    } else {
                      obj5[v.begin + "-" + v.end] = {};
                      obj5[v.begin + "-" + v.end].overPrice = v.over;
                      obj5[v.begin + "-" + v.end].firstWeight = v.price;
                    }
                    obj2.sectionList.map((val) => {
                      if (val.begin === v.begin && val.end === v.end) {
                        val.unitWeight = v.unitWeight;
                        // if (v.over === 0) {
                        //   val.fixedPrice = true;
                        // } else {
                        //   val.fixedPrice = false;
                        // }
                      }
                    });
                  })
                  obj2.tableData.push(obj5)
                })

                obj2.tableData.map(o => {
                  o.ruleDetail.map(v => {
                    obj2.sectionList.map((val) => {
                      if (val.begin === v.begin && val.end === v.end) {
                        let str = v.begin + "-" + v.end;
                        if (!val.fixedPrice) {
                          o[str] = {}
                          o[str].overPrice = v.over;
                          o[str].firstWeight = v.price;
                        }
                      }
                    });
                  })
                })

                if (j.roundTypeList.length === 0 || j.roundTypeList === null) {
                  let roundArr = [
                    {
                      begin: 0,
                      end: "9999.9",
                      roundType: '',
                    },
                  ]
                  obj2.expressRuleRoundTypeReqVoList = roundArr
                } else {
                  obj2.expressRuleRoundTypeReqVoList = j.roundTypeList
                }

                obj.tableList.push(obj2)
              })
            }
            expressTabs.push(obj)
          })

          this.expressTabs = expressTabs
          this.projectsName = projectsName

          this.$bus.emit('getBaseInfoFrom', this.projectBaseInfoFrom)
          this.$bus.emit('projectRentalCostsFrom', this.projectRentalCostsFrom)
          this.$bus.emit('projecttOperationFrom', this.projecttOperationFrom)
          this.$bus.emit('expressTabs', this.expressTabs)
          this.$bus.emit('projectsName', this.projectsName)
          this.$bus.emit('cityDeliveryUnitPrice', this.cityDeliveryUnitPrice)
        }
      });
    },
  }
}